import type { ConfigType } from '@plone/registry';
import userSVG from '@plone/volto/icons/user.svg';
import SpeakerCardView from '../components/Blocks/SpeakerCard/View';
import SpeakerCardEdit from '../components/Blocks/SpeakerCard/Edit';
import { speakerCardSchema } from '../components/Blocks/SpeakerCard/schema';
import WeatherBlock from '../components/Blocks/Weather';

export default function install(config: ConfigType) {
  config.blocks.blocksConfig.speakerCard = {
    id: 'speakerCard',
    title: 'Speaker card',
    icon: userSVG,
    group: 'common',
    view: SpeakerCardView,
    edit: SpeakerCardEdit,
    blockSchema: speakerCardSchema,
    // Returning true keeps the block out of the chooser, so this reads as
    // "restricted everywhere that is not a Talk".
    restricted: ({ contentType }) => contentType !== 'Talk',
    mostUsed: false,
    sidebarTab: 1,
    blockHasOwnFocusManagement: true,
  };
  config.blocks.blocksConfig.weather = WeatherBlock;

  return config;
}
